import { motion } from "framer-motion";
import { MoonStar, Wine } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const PERKS = [
  {
    icon: MoonStar,
    title: "Ouverts, hors zone de couvre-feu",
    text: "Nos cinq maisons sont ouvertes chaque soir et situées en dehors de la zone de couvre-feu.",
  },
  {
    icon: Wine,
    title: "Le Spritz est offert",
    text: "Pendant toute la durée du couvre-feu, le Lillet Spritz est offert dans nos cinq maisons — sur présentation du SMS.",
  },
];

export default function Perks() {
  return (
    <section
      data-testid="perks-section"
      className="border-y border-white/10 bg-coal/60"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-28">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="text-xs uppercase tracking-[0.3em] text-gold/90"
        >
          La promesse
        </motion.p>
        <div className="mt-16 grid gap-12 md:grid-cols-2 md:gap-10">
          {PERKS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
                className="border-l border-gold/30 pl-6"
                data-testid={`perk-${i}`}
              >
                <Icon size={22} className="text-gold" />
                <h3 className="font-display mt-5 text-2xl text-bone">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                  {p.text}
                </p>
              </motion.div>
            );
          })}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.2 }}
          className="mt-16 border-t border-white/10 pt-10 text-center"
          data-testid="sponsors-row"
        >
          <p className="text-[11px] uppercase tracking-[0.25em] text-zinc-500">
            Le Lillet Spritz offert, en partenariat avec
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-14 gap-y-6">
            <img
              src="/logos/lillet.png"
              alt="Lillet"
              className="h-12 w-auto md:h-14"
              data-testid="sponsor-lillet"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
